import { render, staticRenderFns } from "./genericUser.vue?vue&type=template&id=7cc568c8&"
import script from "./genericUser.vue?vue&type=script&lang=js&"
export * from "./genericUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports